<script setup lang="ts">
import { TooltipProvider as RadixTooltipProvider, type TooltipProviderProps } from 'radix-vue'

const props = defineProps<TooltipProviderProps>()
</script>

<template>
  <RadixTooltipProvider v-bind="props">
    <slot />
  </RadixTooltipProvider>
</template>
